import React, { Component } from "react";
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>Projects</h1>
            <div
              id="portfolio-wrapper"
              className="bgrid-quarters s-bgrid-thirds cf"
            >
              {resumeData.portfolio &&
                resumeData.portfolio.map((item, index) => {
                  return (
                    <div
                      key={"proj" + index}
                      className="portfolio-item columns"
                    >
                      <div className="card">
                        <img src={`${item.imgurl}`} className="item-img" />
                        <div className="card-body">
                          <h5 className="card-title">{item.name}</h5>
                          <p>
                            {item.links &&
                              item.links.map((item, index) => {
                                return (
                                  <a
                                    key={"proj-link" + index}
                                    href={item.url}
                                    className="padding-portfolio-icon"
                                  >
                                    <i className={item.className} />
                                    <span className="portfolio-text">
                                      {item.name}
                                    </span>
                                  </a>
                                );
                              })}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
